
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[vertical]",
      function () {
        return require("private-next-pages/[market]/[vertical]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[vertical]"])
      });
    }
  